import { addSeconds, format } from "date-fns";
import React, { useEffect, useState } from "react";

import { useTimer } from "../../../CheckoutDefault/hooks/useTimer";
import { notification } from "../../../services/helpers";
import { sendSmsCodeRequest, validateSmsCodeRequest } from "../../requests";

import { Button, Input } from "..";
import * as Styles from "./styles";

const CODE_LENGTH = 4;
const RESEND_DELAY_SECONDS = 32;

export function SmsPhoneConfirmation({
  msisdn,
  onValidate,
  authToken,
  setIsLoading,
}) {
  const [smsCode, setSmsCode] = useState("");

  const { timer, start } = useTimer({
    mode: "decrease",
    defaultStartTime: addSeconds(new Date(), RESEND_DELAY_SECONDS),
  });
  const [,, ss] = timer;

  const enabledToResendSms = ss < 0;

  async function handleSendSms() {
    try {
      setIsLoading(true);
      await sendSmsCodeRequest({ msisdn, authToken });
      start(addSeconds(new Date(), RESEND_DELAY_SECONDS));
    } catch (error) {
      notification("error", "Erro ao enviar código de acesso");
    } finally {
      setIsLoading(false);
    }
  }

  async function handleValidateSms(e) {
    e.preventDefault();

    try {
      setIsLoading(true);

      const validation = await validateSmsCodeRequest({
        msisdn,
        code: smsCode,
        authToken,
      });

      if (validation.data?.code !== "P00")
        throw new Error(validation.data?.msg);

      onValidate();
    } catch (error) {
      notification(
        "error",
        error?.response?.data?.msg || "Erro ao validar código de acesso"
      );
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    handleSendSms();
  }, []);

  return (
    <Styles.PhoneConfirmationForm>
      <Input
        required
        placeholder="Insira o código aqui"
        maxLength={CODE_LENGTH}
        value={smsCode}
        onChange={(e) => setSmsCode(e.target.value.replace(/\D/g, ""))}
      />
      <footer>
        <Button
          variant="secondary"
          type="button"
          disabled={!enabledToResendSms}
          onClick={handleSendSms}
          color="#22397b99"
        >
          Reenviar código de acesso{" "}
          {ss > 0 ? `em ${ss}s` : ""}
        </Button>
        <Button
          onClick={handleValidateSms}
          disabled={smsCode.length < CODE_LENGTH}
        >
          Validar código
        </Button>
      </footer>
    </Styles.PhoneConfirmationForm>
  );
}
